import { Modal as ModalMui, ModalProps as ModalPropsMui } from '@mui/material';
import React, { ReactNode } from 'react';
import { IconButton } from '../IconButton';
import { CloseIcon } from '../Icons/CloseIcon';
import { LoaderContainer, StyledPageCardContainer } from './styles';

interface ModalProps
  extends Pick<
    ModalPropsMui,
    'open' | 'sx' | 'onClose' | 'ref' | 'onAnimationEnd'
  > {
  readonly title?: string;
  readonly modalClose?: () => void;
  readonly loaderModal?: boolean;
  readonly actionButtons?: ReactNode;
  readonly children: ReactNode;
}

export function Modal({
  modalClose,
  title = 'Title',
  children,
  loaderModal,
  actionButtons,
  ...props
}: ModalProps) {
  return (
    <ModalMui {...props}>
      {loaderModal ? (
        <LoaderContainer>{children}</LoaderContainer>
      ) : (
        <StyledPageCardContainer
          Toolbar={
            <IconButton aria-labelledby="modal-close-icon" onClick={modalClose}>
              <CloseIcon
                aria-label="Close Modal"
                id="modal-close-icon"
                title="close"
              />
            </IconButton>
          }
          cardAction={actionButtons}
          noPadding
          title={title}
        >
          {children}
        </StyledPageCardContainer>
      )}
    </ModalMui>
  );
}
